import React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import { H5Style, Caption } from "storybook-components/Typography";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import Header from "../components/Header";
import SmallCategoryLabel from "../components/PostPreviewCards/SmallCategoryLabel";
import DateAndReadTime from "../components/PostPreviewCards/PublishDate";
import BlogArticleLink from "../components/BlogArticleLink";

const hasCategory = category => {
  if (category) {
    return <SmallCategoryLabel category={category} />;
  }
  return null;
};

const hasAuthor = (edge, author) => {
  if (author) {
    return <AuthorInline>{edge.node.author.name}</AuthorInline>;
  }
  return null;
};

const ArchiveWrapper = styled.div`
  max-width: 744px;
  margin: 0 16px;
  ${props => props.theme.media.desktopUp`
    margin: 0;
  `};
`;

const ArchivePreviewWrapper = styled.div`
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.green5};
  &:last-of-type {
    border-bottom: none;
  }
`;

const PostTitle = styled(BlogArticleLink)`
  ${H5Style}
  color: ${({ theme }) => theme.colors.green4};
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  margin: 0 0 8px;
  &:hover {
    text-decoration: underline;
  }
`;

const Excerpt = styled(Caption)`
  color: ${({ theme }) => theme.colors.gray12};
  margin: 8px 0;
`;

const MetadataWrapper = styled.span`
  display: flex;
`;

const AuthorInline = styled(Caption)`
  color: ${({ theme }) => theme.colors.gray12};
  margin-right: 24px;
`;

const allPages = ({ data }) => (
  <Layout>
    <SEO title="Archive · Mode Blog" pathname="/all" />
    <Header headerText="Archive" />
    <ArchiveWrapper>
      {data.allContentfulBlogPost.edges.map(edge => (
        <ArchivePreviewWrapper key={`archive-preview-${edge.node.slug}`}>
          {hasCategory(edge.node.categories)}

          <PostTitle to={edge.node.slug}>{edge.node.title}</PostTitle>
          <Excerpt>
            {edge.node.longDescription &&
              edge.node.longDescription.childMarkdownRemark.excerpt}
          </Excerpt>

          <MetadataWrapper>
            {hasAuthor(edge, edge.node.author)}
            <DateAndReadTime
              publishDate={edge.node.publishDate}
              readTime={
                !edge.node.richTextBody &&
                edge.node.body.childMarkdownRemark.timeToRead
              }
              richTextData={edge.node.richTextBody}
              color="#5d6374"
            />
          </MetadataWrapper>
        </ArchivePreviewWrapper>
      ))}
    </ArchiveWrapper>
  </Layout>
);

export const query = graphql`
  query archiveQuery {
    allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          id
          title
          longDescription {
            childMarkdownRemark {
              excerpt
            }
          }
          slug
          publishDate
          categories
          author {
            name
          }
          body {
            childMarkdownRemark {
              timeToRead
            }
          }
          richTextBody {
            raw
          }
        }
      }
    }
  }
`;

export default allPages;
